import { Inbox } from "lucide-react";

import { Button } from "@/components/ui/button";

const AppEmptyState = ({
  icon: Icon = Inbox,
  title,
  description,
  actionLabel = null,
  onAction = null,
  actionDisabled = false,
  secondaryLabel = null,
  note = null,
  className = "",
  testId,
}) => {
  const badgeLabel = secondaryLabel || note;

  return (
    <section
      className={`rounded-3xl border border-white/10 glass p-10 ${className}`.trim()}
      data-testid={testId}
    >
      <div className="flex flex-col items-center justify-center text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-3xl border border-white/10 bg-white/[0.04] text-lenvia-blue">
          <Icon className="h-7 w-7" />
        </div>
        <h2 className="mt-5 text-xl font-semibold text-white">{title}</h2>
        {description ? (
          <p className="mt-2 max-w-md text-sm text-slate-400">{description}</p>
        ) : null}

        {badgeLabel ? (
          <p className="mt-5 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-300">
            {badgeLabel}
          </p>
        ) : null}

        {actionLabel && onAction ? (
          <Button
            type="button"
            onClick={onAction}
            disabled={actionDisabled}
            className="btn-primary mt-5"
          >
            {actionLabel}
          </Button>
        ) : null}
      </div>
    </section>
  );
};

export default AppEmptyState;
